import React from 'react'
import cn from 'classnames'

import * as s from './style.module.scss'

// Parent element should be position:relative
export const LoadingPlaceholder = ({ loading = false }) =>
  loading ? <div className={cn({ [s.loading]: loading })} /> : null
